import type { Money } from "./types";

/**
 * Format a backend `Money` for display.
 *
 * Never divides by 100: the backend already produced `decimal` with the right
 * number of places for the currency, and JPY has none — dividing here would
 * show ¥79 for a ¥7899 item (docs/PROJECT.md §Prezzi).
 */
export function formatMoney(locale: string, price: Money | null | undefined): string | null {
  if (!price) return null;
  const value = Number(price.decimal);
  if (!Number.isFinite(value)) return null;
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency: price.currency }).format(value);
  } catch {
    // Unknown currency code — show the raw decimal rather than nothing.
    return `${price.decimal} ${price.currency}`;
  }
}
